import React from "react"

export const DarkContext = React.createContext()
export const GithubContext = React.createContext()
